<template>
  <section class="accreditation-details-card">
    <header v-if="$slots.header" class="accreditation-details-card-heading">
      <slot name="header" />
    </header>
    <div v-if="$slots.default" class="accreditation-details-card-body">
      <slot />
    </div>
    <footer v-if="$slots.footer" class="accreditation-details-card-footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
export default {
  name: 'accreditation-details-card',
}
</script>

<style scoped>
.accreditation-details-card {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  overflow: hidden;
}

.accreditation-details-card-heading {
  background: #f5f5f5;
  padding: 16px 24px;
}

.accreditation-details-card-heading::v-deep h1,
.accreditation-details-card-heading::v-deep h2,
.accreditation-details-card-heading::v-deep .accreditation-details-card-title {
  color: #666666;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.72px;
  line-height: 1.2;
  margin: 0;
}

.accreditation-details-card-heading::v-deep p {
  color: #666666;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 18px;
  line-height: 1.2;
  margin: 2px 0 0;
}

.accreditation-details-card-body {
  padding: 24px;
}

.accreditation-details-card-footer {
  background: #f5f5f5;
  border-top: 1px solid #d9d9d9;
  padding: 24px;
}
</style>
